/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_PaymentInputs */

const en__field_payment = /** @type {(inputs: _Field_PaymentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Payment`)
};

const de__field_payment = /** @type {(inputs: _Field_PaymentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zahlung`)
};

/**
* | output |
* | --- |
* | "Payment" |
*
* @param {_Field_PaymentInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const _field_payment = /** @type {((inputs?: _Field_PaymentInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_PaymentInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en__field_payment(inputs)
	return de__field_payment(inputs)
});